module.exports = __webpack_public_path__ + "static/img/migration.346ec25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/detailed/migration.svg
// module id = NVdk
// module chunks = 0